<script lang="ts">
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import { tooltip } from "app/actions/tooltip";
  import { createEventDispatcher } from "svelte";
  import { Trash } from "$components/+blocks/OVIcon";

  const dispatch = createEventDispatcher();
</script>

<!-- note: the parent wrapper that the gutter menu is in (usually the NodeViewWrapper) needs to have the classes 'group' and 'relative' to make the positioning and visibility on hover work -->
<div
  class="absolute top-0 -left-[24px] hidden w-6 pl-0.5 group-hover:inline-block"
  contenteditable="false"
>
  <div class="flex flex-col items-center">
    <!-- drag handle -->
    <span
      use:tooltip
      title="Drag to move"
      contentEditable={false}
      draggable
      data-drag-handle
      class="text-md cursor-grab text-[1.5rem] font-semibold text-gray-400"
      >⠿
    </span>

    <div class="flex flex-col items-center gap-0.5 text-gray-400">
      <!-- delete -->
      <button
        use:tooltip
        title="Click to delete"
        class="ov-focus mt-1 p-[1px]"
        on:click={() => dispatch("delete-block")}
      >
        <OVIcon icon={Trash} />
      </button>
    </div>
  </div>
</div>
